module.exports = __webpack_public_path__ + "img/cloud.6a3c3fe5.png";